var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIpcaption(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 523,
    height: 101,
    viewBox: "0 0 523 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.383 83.8892H25V35.2033H35.383V83.8892Z",
    fill: "url(#paint0_linear_3350_7076)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.589 48.9459C104.589 51.4319 104.296 53.6525 103.711 55.6078C103.125 57.563 102.326 59.2948 101.315 60.8032C100.33 62.2836 99.1849 63.5545 97.8803 64.6159C96.5758 65.6774 95.2047 66.5433 93.7671 67.2136C92.3561 67.884 90.9184 68.3728 89.4542 68.6801C88.0165 68.9873 86.6588 69.141 85.3809 69.141H61.8994V58.2474H85.3809C86.712 58.1357 87.91 57.8563 88.975 57.4094C90.0665 56.9346 90.9983 56.3061 91.7704 55.524C92.5424 54.7419 93.1415 53.8061 93.5674 52.7168C93.9934 51.5995 94.2064 50.3425 94.2064 48.9459V44.0019C94.0733 42.6332 93.7937 41.3763 93.3678 40.2311C92.9418 39.0858 92.3561 38.1082 91.6106 37.2982C90.8918 36.4881 90.0133 35.8597 88.975 35.4127C87.9367 34.9379 86.7386 34.7005 85.3809 34.7005H61.9793C60.5949 34.7005 59.5433 35.0776 58.8245 35.8317C58.1056 36.5859 57.7462 37.6753 57.7462 39.0998V83.8892H47.3633V39.0998C47.3633 36.3066 47.8425 33.9323 48.8009 31.9771C49.786 30.0218 50.9973 28.4436 52.435 27.2426C53.8992 26.0415 55.4833 25.1756 57.1872 24.6449C58.891 24.0862 60.4618 23.8069 61.8994 23.8069H85.3809C87.7237 23.8069 89.8269 24.1281 91.6905 24.7706C93.5541 25.3851 95.1914 26.223 96.6024 27.2845C98.0401 28.3179 99.2514 29.519 100.236 30.8877C101.248 32.2564 102.073 33.6949 102.712 35.2033C103.378 36.6837 103.857 38.192 104.15 39.7283C104.443 41.2366 104.589 42.6612 104.589 44.0019V48.9459Z",
    fill: "url(#paint1_linear_3350_7076)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.374 83.8892H135.916C134.957 83.8892 133.919 83.7775 132.801 83.554C131.709 83.3026 130.618 82.9255 129.526 82.4228C128.461 81.92 127.436 81.2775 126.451 80.4954C125.466 79.6854 124.587 78.7217 123.815 77.6045C123.07 76.4592 122.471 75.1464 122.018 73.666C121.566 72.1577 121.339 70.4678 121.339 68.5963V39.0998C121.339 38.0942 121.446 37.0189 121.659 35.8736C121.899 34.7005 122.258 33.5553 122.737 32.438C123.216 31.2927 123.842 30.2034 124.614 29.1699C125.386 28.1364 126.305 27.2286 127.37 26.4465C128.461 25.6365 129.712 24.994 131.123 24.5192C132.534 24.0443 134.132 23.8069 135.916 23.8069H173.374V34.7005H135.916C134.558 34.7005 133.519 35.0776 132.801 35.8317C132.082 36.5859 131.722 37.7032 131.722 39.1836V68.5963C131.722 69.9929 132.082 71.0823 132.801 71.8644C133.546 72.6185 134.584 72.9956 135.916 72.9956H173.374V83.8892Z",
    fill: "url(#paint2_linear_3350_7076)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.386 83.8892H229.003V69.141H192.503V83.8892H182.12V53.848C182.12 49.4627 182.838 45.4265 184.276 41.7394C185.714 38.0523 187.71 34.882 190.266 32.2285C192.822 29.5749 195.844 27.5079 199.331 26.0275C202.819 24.5471 206.626 23.8069 210.753 23.8069H234.154C234.873 23.8069 235.552 23.9465 236.191 24.2259C236.83 24.5052 237.389 24.8962 237.868 25.399C238.347 25.9018 238.72 26.4884 238.986 27.1588C239.253 27.8291 239.386 28.5414 239.386 29.2956V83.8892ZM192.503 58.2474H229.003V34.7005H210.753C210.433 34.7005 209.754 34.7563 208.716 34.8681C207.704 34.9519 206.52 35.1893 205.162 35.5803C203.831 35.9714 202.42 36.5719 200.929 37.382C199.438 38.192 198.067 39.3093 196.816 40.7338C195.564 42.1584 194.526 43.9461 193.701 46.0968C192.902 48.2197 192.503 50.8034 192.503 53.848V58.2474Z",
    fill: "url(#paint3_linear_3350_7076)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M308.552 48.9459C308.552 51.4319 308.259 53.6525 307.674 55.6078C307.088 57.563 306.289 59.2948 305.277 60.8032C304.292 62.2836 303.148 63.5545 301.843 64.6159C300.539 65.6774 299.167 66.5433 297.73 67.2136C296.319 67.884 294.881 68.3728 293.417 68.6801C291.979 68.9873 290.622 69.141 289.344 69.141H277.603V58.2474H289.344C290.675 58.1357 291.873 57.8563 292.938 57.4094C294.029 56.9346 294.961 56.3061 295.733 55.524C296.505 54.7419 297.104 53.8061 297.53 52.7168C297.956 51.5995 298.169 50.3425 298.169 48.9459V44.0019C298.036 42.6332 297.756 41.3763 297.331 40.2311C296.905 39.0858 296.319 38.1082 295.573 37.2982C294.855 36.4881 293.976 35.8597 292.938 35.4127C291.899 34.9379 290.701 34.7005 289.344 34.7005H265.942C264.558 34.7005 263.506 35.0776 262.787 35.8317C262.068 36.5859 261.709 37.6753 261.709 39.0998V83.8892H251.326V39.0998C251.326 36.3066 251.805 33.9323 252.764 31.9771C253.749 30.0218 254.96 28.4436 256.398 27.2426C257.862 26.0415 259.446 25.1756 261.15 24.6449C262.854 24.0862 264.425 23.8069 265.862 23.8069H289.344C291.686 23.8069 293.79 24.1281 295.653 24.7706C297.517 25.3851 299.154 26.223 300.565 27.2845C302.003 28.3179 303.214 29.519 304.199 30.8877C305.211 32.2564 306.036 33.6949 306.675 35.2033C307.341 36.6837 307.82 38.192 308.113 39.7283C308.406 41.2366 308.552 42.6612 308.552 44.0019V48.9459Z",
    fill: "url(#paint4_linear_3350_7076)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.212 34.7005H346.33V83.8892H335.947V34.7005H313.025V23.8069H369.212V34.7005Z",
    fill: "url(#paint5_linear_3350_7076)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M431.071 83.8892H420.688V69.141H384.188V83.8892H373.805V53.848C373.805 49.4627 374.524 45.4265 375.961 41.7394C377.399 38.0523 379.396 34.882 381.952 32.2285C384.507 29.5749 387.529 27.5079 391.017 26.0275C394.504 24.5471 398.311 23.8069 402.438 23.8069H425.84C426.558 23.8069 427.237 23.9465 427.876 24.2259C428.515 24.5052 429.074 24.8962 429.553 25.399C430.033 25.9018 430.405 26.4884 430.672 27.1588C430.938 27.8291 431.071 28.5414 431.071 29.2956V83.8892ZM384.188 58.2474H420.688V34.7005H402.438C402.118 34.7005 401.44 34.7563 400.401 34.8681C399.39 34.9519 398.205 35.1893 396.847 35.5803C395.516 35.9714 394.105 36.5719 392.614 37.382C391.123 38.192 389.752 39.3093 388.501 40.7338C387.25 42.1584 386.211 43.9461 385.386 46.0968C384.587 48.2197 384.188 50.8034 384.188 53.848V58.2474Z",
    fill: "url(#paint6_linear_3350_7076)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M453.634 83.8892H443.251V32.2285H453.634V83.8892Z",
    fill: "url(#paint7_linear_3350_7076)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M523 79.2385C523 80.0206 522.854 80.7468 522.561 81.4172C522.294 82.0876 521.922 82.6742 521.443 83.1769C520.99 83.6518 520.444 84.0289 519.805 84.3082C519.166 84.5875 518.487 84.7272 517.769 84.7272C517.13 84.7272 516.477 84.6015 515.812 84.3501C515.173 84.0987 514.6 83.6937 514.095 83.135L476.157 41.5718V83.8892H465.774V28.4576C465.774 27.3403 466.067 26.3348 466.652 25.4409C467.265 24.5192 468.037 23.8348 468.969 23.3879C469.954 22.9689 470.965 22.8712 472.004 23.0946C473.042 23.2901 473.934 23.7929 474.679 24.603L512.617 66.1243V23.8069H523V79.2385Z",
    fill: "url(#paint8_linear_3350_7076)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3350_7076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.143 18.4892C443.143 18.219 443.362 18 443.632 18H453.321C453.591 18 453.81 18.219 453.81 18.4892V28.7031C453.81 28.9733 453.591 29.1923 453.321 29.1923H443.632C443.362 29.1923 443.143 28.9733 443.143 28.7031V18.4892Z",
    fill: "#24852A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3350_7076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 20.3554C25 20.0852 25.219 19.8662 25.4892 19.8662H35.1785C35.4487 19.8662 35.6677 20.0852 35.6677 20.3554V30.5693C35.6677 30.8395 35.4487 31.0586 35.1785 31.0586H25.4892C25.219 31.0586 25 30.8395 25 30.5693V20.3554Z",
    fill: "#65C06C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3350_7076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.164 58.5962C264.164 58.326 264.383 58.1069 264.653 58.1069H274.342C274.612 58.1069 274.831 58.326 274.831 58.5962V68.8101C274.831 69.0802 274.612 69.2993 274.342 69.2993H264.653C264.383 69.2993 264.164 69.0802 264.164 68.8101V58.5962Z",
    fill: "#40993E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3350_7076",
    x: 418.681,
    y: 0.0618005,
    width: 59.5898,
    height: 60.1147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.52298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3350_7076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3350_7076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3350_7076",
    x: 0.538818,
    y: 1.92801,
    width: 59.5901,
    height: 60.1147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.52298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3350_7076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3350_7076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3350_7076",
    x: 239.702,
    y: 40.1687,
    width: 59.5898,
    height: 60.1147,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.52298
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.2306
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.85098 0 0 0 0 0.607843 0 0 0 0 0.0156863 0 0 0 0.49 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3350_7076"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3350_7076",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3350_7076",
    x1: 25,
    y1: 34.2497,
    x2: 371.678,
    y2: 78.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66C16D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22852A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIpcaption);
export default __webpack_public_path__ + "static/media/ipcaption.854c6adf93cb2ae64a2946df47f74193.svg";
export { ForwardRef as ReactComponent };